import React from 'react';

type BusinessIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function BusinessIcon({
  width = '38',
  height = '34',
  color = '#6267AC',
}: BusinessIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 38 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.4997 15.3333H6.66634C5.73292 15.3333 5.26621 15.3333 4.90969 15.515C4.59609 15.6748 4.34112 15.9297 4.18133 16.2433C3.99967 16.5999 3.99967 17.0666 3.99967 18V32M26.4997 15.3333H31.333C32.2664 15.3333 32.7331 15.3333 33.0897 15.515C33.4033 15.6748 33.6582 15.9297 33.818 16.2433C33.9997 16.5999 33.9997 17.0666 33.9997 18V32M26.4997 32V7.33333C26.4997 5.46649 26.4997 4.53307 26.1364 3.82003C25.8168 3.19282 25.3069 2.68289 24.6796 2.36331C23.9666 2 23.0332 2 21.1663 2H16.833C14.9662 2 14.0327 2 13.3197 2.36331C12.6925 2.68289 12.1826 3.19282 11.863 3.82003C11.4997 4.53307 11.4997 5.46649 11.4997 7.33333V32M35.6663 32H2.33301M17.333 8.66667H20.6663M17.333 15.3333H20.6663M17.333 22H20.6663'
        stroke={color}
        stroke-width='4'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default BusinessIcon;
